<template>
	<div class="bcgl">
		<div style="margin: 0rem 0 0 0rem; border: 1px #DDDDDD solid;">
			<el-card class="box-card">
				<div slot="header">
					<el-row style="margin-bottom: 20px">
						<el-col :span="24">
							<div style="line-height: 3rem; font-size: 1.5rem;">退休人员</div>
						</el-col>

					</el-row>
					<el-row style="text-align: left">
						<el-form :inline="true" :model="form" @keyup.enter.native="selectChanged3">
							<el-form-item label="大队" >
								<el-select clearable :disabled="deptdisable"  @change="changeIndex"   filterable   v-model="form.zzdyqc"  placeholder="请选择大队">
									<el-option
											v-for="item in depts"
											:key="item.bmid"
											:label="item.bmmc"
											:value="item.bmid"
											:disabled="deptdisable">
									</el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="姓名">
								<el-input  style="width: 150px"    placeholder="姓名" v-model="form.xm" prefix-icon="el-icon-user" @change="changeIndex"  clearable >
								</el-input>
							</el-form-item>
							<el-form-item label="退休日期">
								<el-date-picker
										v-model="startTime"
										type="daterange"
										@change="changeIndex"
										value-format="yyyy-MM-dd"
										range-separator="至"
										start-placeholder="开始日期"
										end-placeholder="结束日期">
								</el-date-picker>
							</el-form-item>
							<!--<el-form-item label="岗位">
								<el-input style="width: 150px"     placeholder="岗位" v-model="form.gw" prefix-icon="el-icon-user" clearable >
								</el-input>
							</el-form-item>-->
							<el-form-item label="是否退工">
								<el-select clearable :disabled="deptdisable"   @change="changeIndex" v-model="form.isTg" placeholder="请选择" style="width: 120px">
									<el-option :key="0" :label="'否'" :value="0"></el-option>
									<el-option :key="1" :label="'是'" :value="1"></el-option>
								</el-select>
							</el-form-item>
							<el-form-item>
								<el-button @click="selectChanged3()">查询</el-button>
							</el-form-item>
						</el-form>
					</el-row>
				</div>

				<el-table
						  :header-cell-class-name="handleHeaderClass"
						  @sort-change="handleTableSort"
						:data="contractList" v-loading="loading"  style="text-align: center; width: 100%;">
					<el-table-column prop="username" label="用户编号" >
					</el-table-column>
					<el-table-column prop="xm" label="用户名" >
						<template slot-scope="scope">
						<el-button type="text" @click="showUser(scope.row)">{{
							scope.row.xm
							}}</el-button>
						</template>
					</el-table-column>
					<el-table-column label="岗位" prop="t.gw" width="200" show-overflow-tooltip sortable="custom">
						<template slot-scope="scope">
							{{scope.row.gw}}
						</template>
					</el-table-column>
					<el-table-column label="出生日期" prop="t.csrq"  sortable="custom">
						<template slot-scope="scope">
							{{scope.row.csrq}}
						</template>
					</el-table-column>
					<el-table-column label="年齡">
						<template slot-scope="scope">
							{{getAge(scope.row.csrq)}}
						</template>
					</el-table-column>
					<el-table-column label="部门"  prop="t.zzdyqc" sortable="custom">
						<template slot-scope="scope">
							{{scope.row.zzdyqc}}
						</template>
					</el-table-column>
					<el-table-column label="是否退工"  prop="isTg">
						<template slot-scope="scope">
							<el-tag v-if="scope.row.isTg==0" type="success">未退工</el-tag>
							<el-tag v-else-if="scope.row.isTg==1"  type="info">已退工</el-tag>
						</template>
					</el-table-column>
					<el-table-column label="退休日期"  prop="txrq" sortable="custom">
					</el-table-column>

					<el-table-column label="操作" fixed="right" width="120" :render-header="renderHeader">
						<template slot-scope="scope">
							<el-button type="text" size="mini" v-if="isAuth('user:update')"  @click="setSize(scope.row)">{{scope.row.isTg ==0?'退工':'修改'}}</el-button>
<!--							<el-button type="text" size="mini" v-if="isAuth('equip:out')"  @click="setSize(scope.row)">设置尺寸</el-button>-->
						</template>
					</el-table-column>
				</el-table>
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentNo"
				 :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="pageTotal">
				</el-pagination>
			</el-card>
		</div>
		<el-dialog
				style="text-align: left"
				title="导出"
				:visible.sync="exportVisible"
		>
			<el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
			<el-checkbox-group v-model="fieldList" @change="handleCheckedItemChange">
				<el-checkbox v-for="field in fields" :label="field.value" :key="field.value">{{field.name}}</el-checkbox>
			</el-checkbox-group>
			<form ref="exportForm" method="post" :action="this.$request.defaults.baseURL+'/bjba/yhgl/exportTxExcel?access_token='+this.$store.getters.token"  target="_blank">
				<input type="hidden" v-for="(value,key,index) in form" :name="key"  :value="value" />
				<input type="hidden" name="fileds" value="" ref="fileds"/>
			</form>
			<span slot="footer" class="dialog-footer">
    <el-button @click="exportVisible = false">取 消</el-button>
    <el-button type="primary" @click="exportExcel">确 定</el-button>
  </span>
		</el-dialog>
		<set-tg v-if="setSizeVisible" ref="setSize" @refreshDataList="getUserList"></set-tg>
	</div>
</template>
<script>
	import {
		Vue,
		Component
	} from 'vue-property-decorator'
	import Template from "@/template.vue";

	import SetTg from './set-tg'
	const exportFields=[
		{value:"username",name:"工号"},
		{value:"xm",name:"姓名"},
		{value:"csrq",name:"出生日期"},
		{value:"age",name:"年龄"},
		{value:"txrq",name:"退休日期"},
		{value:"jrgsrq",name:"进入公司日期"},
		{value:"zzdyqc",name:"部门"},
		{value:"isTg",name:"是否退工"},
		{value:"tgrq",name:"退工日期"},
		{value:"gw",name:"岗位"},
		{value:"xb",name:"性别"}
	]
	@Component({
		name: 'contractinfo',
		components:{
			Template,
			SetTg
		}
	})
	export default class contractinfo extends Vue {
		customerVisible=false
		currentNo = 1;
		pageSize = 10;
		pageTotal = 0;
		childDept = [];
		activeNames=[];
		customerUserVisible = false
		showbmxxVisible = false;
		customerList=[]
		showfileVisible=false
		showInfoVisible=false
		setSizeVisible=false
		showInfoVisible2=false
		types=[]
		form={
			zzdyqc:'',
			xm:'',
			txTimest:'',
			txTimeed:'',
			isTg:'',
			orders:''
		}
		startTime=[]
		endTime=[]
		childdeptdisable=false
		deptdisable =false
		amount=['','']
		contractList=[]
		bmxx=[]
		loading = false;
		dataListSelections=[];
		sjbm=[]
		depts=[]
		orders=[]
		selectBm=''
		isIndeterminate= false
		exportVisible=false
		checkAll=false
		fields=exportFields
		filedValues=exportFields.map(item => item.value)
		fieldList=[]
		created() {
			this.getDepts()
			this.getUserList()
		}

		handleSizeChange(val) {
			this.pageSize = val;
			this.getUserList();
		}
		handleCurrentChange(val) {
			this.currentNo = val;
			this.getUserList();
		}
// 设置列的排序为我们自定义的排序
		handleHeaderClass({ column }) {
			if(!column.multiOrder) column.multiOrder =''
			column.order = column.multiOrder
		}
		handleOrderChange (orderColumn, orderState) {
			let result = this.orders.find(e => e.orderColumn === orderColumn)
			if (result) {
				if(orderState)
					result.orderState = orderState
				else {
					var j =this.orders.indexOf(result);
					if(j !== -1) {
						this.orders.splice(j,1);
					}
				}
			} else {
				this.orders.push({
					orderColumn: orderColumn,
					orderState: orderState
				})
			}
			this.getUserList()
		}
// 上面缺点是只能通过点击表头切换排序状态，点击小三角排序不会触发，处理sort-change事件和点击表头一样
// 列表排序
		handleTableSort({ column }) {
			console.log(column.orderfield)
			column.multiOrder = column.order
			this.handleOrderChange(column.property, column.multiOrder)
		}
		getParams() {
			this.form.orders = encodeURI(JSON.stringify(this.orders))
			this.form.page = this.currentNo;
			this.form.pagesize = 10
			this.form.userid = this.$store.getters.username
			if(this.startTime &&this.startTime.length==2){
				this.form.txTimest = this.startTime[0]
				this.form.txTimeed = this.startTime[1]
			} else{
				this.form.txTimest = ''
				this.form.txTimeed = ''
			}
		}
		renderHeader (h) {
			return (
					<div class="clearfix">
						<span>操作</span>
						<el-button style="padding:5px;float:right" size="mini"
								   onClick={()=>this.showExportDialog()}>导出</el-button></div>
			)
		}
		handleCheckAllChange(val) {
			this.fieldList = val ? this.filedValues: [];
			this.isIndeterminate = false;
		}
		handleCheckedItemChange(value) {
			let checkedCount = value.length;
			this.checkAll = checkedCount === this.filedValues.length;
			this.isIndeterminate = checkedCount > 0 && checkedCount < this.fields.length;
		}

		showExportDialog() {
			this.exportVisible = true
		}
		exportExcel() {

			var filedLast = this.fields.filter(filed=>{
				return this.fieldList.indexOf(filed.value) !==-1
			})
			if(filedLast && filedLast.length>0) {
				this.getParams();
				this.$refs.fileds.value = JSON.stringify(filedLast)
				this.$refs.exportForm.submit();
			} else {
				this.$message({
					message: '请选择字段',
					type: 'error',
					duration: 1500
				})
				return
			}
		}
		setSize(row){

			this.setSizeVisible = true
			var data = {userid: '',tgrq:'',tgyy:''}
			data.userid = row.id
			data.tgrq = row.tgrq
			data.tgyy = row.tgyy
			this.$nextTick(() => {
				this.$refs.setSize.init(data)
			})
		}

		getDepts() {
			let that = this;
			this.$request.get('/bjba/kqtj/getFirstMentForUser',{
				params: {
					userid:this.$store.getters.username
				}

			}).then(res => {
				that.depts = res.data
			})
		}
		showUser(user) {
			this.$router.push({
				path: "/bjba/grzx",
				query: { username: user.username },
			});
		}

		getAge(strBirthday) {
			var birArr = strBirthday.split("-");
			var birYear = birArr[0];
			var birMonth = birArr[1];
			var birDay = birArr[2];

			d = new Date();
			var nowYear = d.getFullYear();
			var nowMonth = d.getMonth() + 1; //记得加1
			var nowDay = d.getDate();
			var returnAge;

			if (birArr == null) {
				return false
			};
			var d = new Date(birYear, birMonth - 1, birDay);
			if (d.getFullYear() == birYear && (d.getMonth() + 1) == birMonth && d.getDate() == birDay) {
				if (nowYear == birYear) {
					returnAge = 0; //
				} else {
					var ageDiff = nowYear - birYear; //
					if (ageDiff > 0) {
						if (nowMonth == birMonth) {
							var dayDiff = nowDay - birDay; //
							if (dayDiff < 0) {
								returnAge = ageDiff - 1;
							} else {
								returnAge = ageDiff;
							}
						} else {
							var monthDiff = nowMonth - birMonth; //
							if (monthDiff < 0) {
								returnAge = ageDiff - 1;
							} else {
								returnAge = ageDiff;
							}
						}
					} else {
						return  "出生日期晚于今天，数据有误"; //返回-1 表示出生日期输入错误 晚于今天
					}
				}
				return returnAge;
			} else {
				return ("输入的日期格式错误！");
			}
		}

		selectChanged3(value) {
			this.getUserList();
		}
		changeIndex() {
			this.currentNo = 1;
		}

		getUserList () {
			this.loading = true
			this.getParams()
			this.$request.get('/bjba/yhgl/findTxUser', {
				params: this.form
			}).then(res => {
				const {
					data
				} = res
				console.log("列表数据：", data)
				this.contractList = data.data.content
				this.pageTotal = data.data.totalElements
				this.loading = false
			}).catch(err => {
				this.$message({
					message: '获取用户列表出现异常!',
					type: 'error',
					center: true,
					showClose: true
				})
				this.loading = false
				console.log(err)
			})
		}
	}
</script>
<style lang="scss" scoped>
	.bcgl {}
</style>
